module.exports = __webpack_public_path__ + "images/free_spins_image_0d34b519798581ea41bfa6de5654535e.webp";